import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid
} from "@mui/material";
import Select from "react-select";
import SchemeReportController from "pages/Controller/SchemeReportController";

/* ================= CHECKBOX OPTION (same pattern) ================= */
const CheckboxOption = (props) => {
    const { label } = props.data;
    const { isSelected, selectOption } = props;

    const handleSelect = (e) => {
        e.preventDefault();
        e.stopPropagation();
        selectOption(props.data);
    };

    return (
        <div
            role="option"
            aria-selected={isSelected}
            tabIndex={0}
            onMouseDown={handleSelect}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") handleSelect(e);
            }}
            style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 10px",
                cursor: "pointer",
                background: "#fff"
            }}
        >
            <input type="checkbox" checked={isSelected} readOnly />
            <span style={{ marginLeft: 8, color: "#000" }}>{label}</span>
        </div>
    );
};

const NoMultiValue = () => null;

/* ================= SELECT STYLES ================= */
const singleLineSelectStyles = {
    menuPortal: (b) => ({ ...b, zIndex: 9999 }),
    control: (base) => ({
        ...base,
        minHeight: 38,
        height: 38
    }),
    valueContainer: (base) => ({
        ...base,
        height: 38,
        padding: "0 8px",
        overflow: "hidden"
    }),
    placeholder: (base) => ({
        ...base,
        color: "#000",
        fontWeight: 500
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: 38
    })
};

const SchemeReport = () => {
    const {
        schemeOptions,
        zoneOptions,
        customerNameOptions,
        filters,
        setFilters,
        schemeData,
        handleCustomerSearch
    } = SchemeReportController();

    return (
        <div className="bg" style={{ display: "block" }}>

            {/* ================= TITLE ================= */}
            <div style={{ textAlign: "center" }}>
                <span className="font20">Scheme Report</span>
            </div>

            <div className="orderrow"></div>

            {/* ================= FILTERS ================= */}
            <Grid container spacing={2} sx={{ mb: 3 }}>

                {/* SCHEMES */}
                <Grid item xs={12} md={4}>
                    <Select
                        options={schemeOptions}
                        value={filters.scheme}
                        onChange={(v) =>
                            setFilters((p) => ({ ...p, scheme: v }))
                        }
                        placeholder="SCHEMES"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={singleLineSelectStyles}
                    />
                </Grid>

                {/* CUSTOMER */}
                <Grid item xs={12} md={4}>
                    <Select
                        options={customerNameOptions}
                        value={filters.customerName}
                        onChange={(v) =>
                            setFilters((p) => ({ ...p, customerName: v }))
                        }
                        onInputChange={(val, { action }) => {
                            if (action === "input-change" && val.length >= 3) {
                                handleCustomerSearch(val);
                            }
                        }}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        controlShouldRenderValue={false}
                        components={{
                            Option: CheckboxOption,
                            MultiValue: NoMultiValue
                        }}
                        placeholder="CUSTOMER NAME"
                        styles={singleLineSelectStyles}
                        menuPortalTarget={document.body}
                    />
                </Grid>

                {/* ZONE */}
                <Grid item xs={12} md={4}>
                    <Select
                        options={zoneOptions}
                        value={filters.zone}
                        onChange={(v) =>
                            setFilters((p) => ({ ...p, zone: v }))
                        }
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        controlShouldRenderValue={false}
                        components={{
                            Option: CheckboxOption,
                            MultiValue: NoMultiValue
                        }}
                        placeholder="ZONE"
                        styles={singleLineSelectStyles}
                        menuPortalTarget={document.body}
                    />
                </Grid>
            </Grid>

            {/* ================= TABLE ================= */}
            <Paper sx={{ width: "100%" }}>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                {[
                                    "SCMNAME",
                                    "ZONE CD",
                                    "ZONE",
                                    "CUST_GROUP",
                                    "CUSTOMER CODE",
                                    "CUSTOMER NAME",
                                    "BENIFIT DESC",
                                    "DIVISION",
                                    "MST MG",
                                    "BILL NO"
                                ].map((h) => (
                                    <TableCell
                                        key={h}
                                        align="center"
                                        sx={{
                                            background: "red",
                                            color: "#fff",
                                            fontWeight: 600
                                        }}
                                    >
                                        {h}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {schemeData.length ? (
                                schemeData.map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell align="center">{row.scmname}</TableCell>
                                        <TableCell align="center">{row.zone_cd}</TableCell>
                                        <TableCell align="center">{row.zone}</TableCell>
                                        <TableCell align="center">{row.cust_group}</TableCell>
                                        <TableCell align="center">{row.customer_code}</TableCell>
                                        <TableCell align="center">{row.customer_name}</TableCell>
                                        <TableCell align="center">{row.benefit_desc}</TableCell>
                                        <TableCell align="center">{row.division}</TableCell>
                                        <TableCell align="center">{row.mst_mg}</TableCell>
                                        <TableCell align="center">{row.bill_no}</TableCell>
                                    </TableRow>

                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No Scheme Data Found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

        </div>
    );
};

export default SchemeReport;
